/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCreate
 */
export interface UserCreate {
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    last_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserCreate
     */
    grade?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    avatar_image?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreate
     */
    is_active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreate
     */
    has_avatar?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    password?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserCreate
     */
    role_ids?: Array<number> | null;
}

/**
 * Check if a given object implements the UserCreate interface.
 */
export function instanceOfUserCreate(value: object): value is UserCreate {
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function UserCreateFromJSON(json: any): UserCreate {
    return UserCreateFromJSONTyped(json, false);
}

export function UserCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'grade': json['grade'] == null ? undefined : json['grade'],
        'avatar_image': json['avatar_image'] == null ? undefined : json['avatar_image'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'has_avatar': json['has_avatar'] == null ? undefined : json['has_avatar'],
        'password': json['password'] == null ? undefined : json['password'],
        'role_ids': json['role_ids'] == null ? undefined : json['role_ids'],
    };
}

export function UserCreateToJSON(json: any): UserCreate {
    return UserCreateToJSONTyped(json, false);
}

export function UserCreateToJSONTyped(value?: UserCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'phone': value['phone'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'grade': value['grade'],
        'avatar_image': value['avatar_image'],
        'is_active': value['is_active'],
        'has_avatar': value['has_avatar'],
        'password': value['password'],
        'role_ids': value['role_ids'],
    };
}

